// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5234":"f1af3406b4c97dd3","5702":"61144cad46a43764","6975":"5778c6c2406ed9f3","8840":"61144cad46a43764","9484":"ffd8182d96f4d108"}[chunkId] + ".css";
};